module.exports = __webpack_public_path__ + "static/media/back.68625d1d.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/ui/back.svg
// module id = 169
// module chunks = 0